import type { ApprovalWorkflow } from "@/lib/api/catalog";

export const CATALOG_APPROVAL_OPTIONS: {
  value: ApprovalWorkflow;
  title: string;
  description: string;
}[] = [
  {
    value: "disabled",
    title: "Disabled",
    description: "A finished record publishes immediately. The review queue stays empty.",
  },
  {
    value: "optional",
    title: "Optional",
    description: "Catalogers can publish immediately, save a draft, or submit for review.",
  },
  {
    value: "required",
    title: "Required",
    description: "Every new record waits in the review queue until a reviewer approves it.",
  },
];
